import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin, Phone } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-muted mt-20">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company info */}
          <div>
            <div className="gradient-primary text-white px-3 py-2 rounded-lg font-bold text-xl inline-block mb-4">
              ELL-MONT
            </div>
            <p className="text-muted-foreground mb-4">
              Vaš pouzdan partner za električne materijale u Rožajama i širom Crne Gore.
            </p>
            <a 
              href="https://instagram.com/ell__mont" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-muted-foreground hover:text-primary transition-fast"
            >
              <Instagram className="h-5 w-5" />
              <span>@ell__mont</span>
            </a>
          </div>

          {/* Quick links */}
          <div>
            <h3 className="font-semibold mb-4">Brzi Linkovi</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-muted-foreground hover:text-primary transition-fast">
                  Početna
                </Link>
              </li>
              <li>
                <Link to="/proizvodi" className="text-muted-foreground hover:text-primary transition-fast">
                  Proizvodi
                </Link>
              </li>
              <li>
                <Link to="/o-nama" className="text-muted-foreground hover:text-primary transition-fast">
                  O Nama
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-muted-foreground hover:text-primary transition-fast">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Customer service */}
          <div>
            <h3 className="font-semibold mb-4">Korisnička Podrška</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/kontakt" className="text-muted-foreground hover:text-primary transition-fast">
                  Kontakt
                </Link>
              </li>
              <li>
                <Link to="/uslovi" className="text-muted-foreground hover:text-primary transition-fast">
                  Uslovi Korišćenja
                </Link>
              </li>
              <li>
                <Link to="/privatnost" className="text-muted-foreground hover:text-primary transition-fast">
                  Politika Privatnosti
                </Link>
              </li>
              <li>
                <Link to="/dostava" className="text-muted-foreground hover:text-primary transition-fast">
                  Dostava i Povraćaj
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold mb-4">Kontakt</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-muted-foreground">
                <MapPin className="h-5 w-5 mt-0.5 flex-shrink-0" />
                <span>Rožaje, Crna Gora</span>
              </li>
              <li className="flex items-start gap-2 text-muted-foreground">
                <Phone className="h-5 w-5 mt-0.5 flex-shrink-0" />
                <div className="flex flex-col">
                  <a href="tel:+38267250197" className="hover:text-primary transition-fast">+382 67 250 197</a>
                  <a href="tel:+38268884188" className="hover:text-primary transition-fast">+382 68 884 188</a>
                  <a href="tel:+38268764128" className="hover:text-primary transition-fast">+382 68 764 128</a>
                </div>
              </li>
              <li className="flex items-center gap-2 text-muted-foreground">
                <Mail className="h-5 w-5 flex-shrink-0" />
                <a href="mailto:ell.mont10@gmail.com" className="hover:text-primary transition-fast">
                  ell.mont10@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t mt-8 pt-8 text-center text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} ELL-MONT doo. Sva prava zadržana.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
